import { getValidationMessages } from '@/common/constants/validation-messages';
import * as yup from 'yup';

const messages = getValidationMessages();

export const partiesSchema = yup
  .object()
  .shape({
    party_id: yup.string(),
    harvest_type: yup.string(),
  })
  .test('at-least-one', messages.required, (values) =>
    Boolean(values.party_id || values.harvest_type),
  );
